import React from 'react';
import PropTypes from 'prop-types';
import { Carousel } from '@one-thd/sui-carousel';
import {
  Card,
  CardMedia,
  CardTitle,
  Typography
} from '@one-thd/sui-atomic-components';
import { akamaiImageResize } from '../utils';

const CardCarouselRenderer = ({ entryId, data, recPodList, inspectorId = null }) => {

  function selectImageSrc(image) {
    const damImage = image?.damContentSelector?.assetData?.[0]?.selectedImageUrl;
    const nonDamImage = image?.damDownloadedContent?.url;
    return damImage || nonDamImage;
  }

  const slides = recPodList.map((item) => {
    const cardImage = akamaiImageResize(selectImageSrc(item?.image));
    if (cardImage) {
      return (
        <Card href={item.url} key={`card-${item.anchorText}`}>
          <CardMedia
            src={cardImage}
            aspect="square"
            alt={`Image for ${item.anchorText}`}
            data-contentful-entry-id={item.sys?.id || item.id}
            data-contentful-field-id="image"
          />
          <CardTitle
            header={(
              <Typography
                component="h3"
                variant="h5"
                data-contentful-entry-id={item.sys?.id || item.id}
                data-contentful-field-id="anchorText"
              >
                {item.anchorText}
              </Typography>
            )}
          />
        </Card>
      );
    }
    return null;
  }).filter(Boolean);

  return (
    <div data-component="CardCarousel">
      <Carousel
        title={(
          <Typography
            variant="h2"
            weight="display"
            data-contentful-entry-id={inspectorId}
            data-contentful-field-id="podTitle"
          >
            {data.podTitle}
          </Typography>
        )}
        disableMargin
        spaceBetween={12}
      >
        {slides}
      </Carousel>
    </div>
  );
};

CardCarouselRenderer.propTypes = {
  entryId: PropTypes.string.isRequired,
  inspectorId: PropTypes.string,
  data: PropTypes.shape({
    podTitle: PropTypes.string.isRequired
  }).isRequired,
  recPodList: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    url: PropTypes.string,
    anchorText: PropTypes.string,
    image: PropTypes.shape({
      damContentSelector: PropTypes.shape({
        assetData: PropTypes.arrayOf(PropTypes.shape({
          selectedImageUrl: PropTypes.string
        }))
      }),
      damDownloadedContent: PropTypes.shape({
        url: PropTypes.string
      })
    })
  })).isRequired
};

export { CardCarouselRenderer };
